module.exports = __webpack_public_path__ + "img/tw.06ddd5b9.svg";